<template>
  <div class="InfoCoach">
    <div>
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890ff">▋</span>基本信息
      </div>
      <div class="alnCt mt20 descCont">
        <div class="avaCont">
          <a-avatar shape="square" :size="180" :src="info.headImageUrl" />
        </div>
        <div class="flx1">
          <el-descriptions title="" :column="3" border>
            <el-descriptions-item label="姓名">{{ info.name || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身高(cm)">{{ info.height || '-' }}</el-descriptions-item>
            <el-descriptions-item label="家庭地址">{{ info.addressName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="籍贯">{{ info.nativePlaceName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="体重(kg)">{{ info.weight || '-' }}</el-descriptions-item>
            <el-descriptions-item label="详细地址">{{ info.detailedAddress || '-' }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{info.sex == 1 ? '男' : '女'}}</el-descriptions-item>
            <el-descriptions-item label="手机号码">{{ info.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="所在机构">{{ info.employerName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="生日">{{ info.birthday || '-' }}</el-descriptions-item>
            <el-descriptions-item label="身份证号码">{{ info.idCardNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="入队时间">{{ info.workingTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="年龄">{{ info.age || '-' }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ info.email || '-' }}</el-descriptions-item>
            <el-descriptions-item label="教学项目">{{ info.teachingProject || '-' }}</el-descriptions-item>
            <el-descriptions-item label="职位">{{ info.positionName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="所属组别">{{info.teamName || '-'}}/{{info.groupName || '-'}}</el-descriptions-item>
            <el-descriptions-item label=" "></el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890ff">▋</span>教育经历
      </div>
      <div class="wz-mt-2 memberInfo">
        <a-table
          bordered
          :pagination="false"
          :rowKey="(record) => record.id"
          :columns="jyColumns"
          :data-source="info.educations ? info.educations : []"
        >
          <span slot="degree" slot-scope="text, record">
            <div>{{ $filters.toIdListName(record.degree, educateData) }}</div>
          </span>
        </a-table>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890ff">▋</span>执教履历
      </div>
      <div class="wz-mt-2 memberInfo">
        <a-table
          bordered
          :pagination="false"
          :rowKey="(record) => record.id"
          :columns="zjColumns"
          :data-source="info.teaches ? info.teaches : []"
        >
        </a-table>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890ff">▋</span>其他信息
      </div>
      <div class="mt20">
        <el-descriptions title="" :column="1" border  class="otherDesc">
          <el-descriptions-item label="备注">{{info.remark || '无备注'}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="mt20">
      <div class="alnCt ant-descriptions-title">
        <span style="color: #1890ff">▋</span>操作记录
      </div>
      <div class="wz-pl-2">
        <a-empty v-if="operatingList.length <= 0" :image="simpleImage" />
        <div class="mt10" v-for="(item, index) in operatingList" :key="index">
          <a-badge color="#108ee9" :text="item.dayTxt" />
          <div class="mt10">
            <a-card>
              <div class="spcBt">
                <div>
                  <a-avatar size="large" :src="item.headImageUrl">
                    <template #icon>
                      <UserOutlined />
                    </template>
                  </a-avatar>
                  <span class="ml10">{{ item.name }}</span>
                </div>
                <div>{{ item.timeTxt }}</div>
              </div>
              <div class="mt10">操作：{{ item.operatingType }}</div>
            </a-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
const jyColumns = [
  {
    title: "学校名称",
    dataIndex: "collegeName",
    key: "collegeName",
    align: "center",
  },
  {
    title: "学历",
    dataIndex: "degree",
    key: "degree",
    align: "center",
    scopedSlots: { customRender: "degree" },
  },
  { title: "专业", dataIndex: "major", key: "major", align: "center" },
  {
    title: "教育时间",
    dataIndex: "educationTime",
    key: "educationTime",
    align: "center",
    customRender: function (val) {
      return val.length
        ? `${moment(+val[0]).format("yyyy")}-${moment(+val[1]).format("yyyy")}`
        : "";
    },
  },
];
const zjColumns = [
  {
    title: "公司名称",
    dataIndex: "companyName",
    key: "companyName",
    align: "center",
  },
  { title: "职位", dataIndex: "position", key: "position", align: "center" },
  {
    title: "执教时间",
    dataIndex: "teachingTime",
    key: "teachingTime",
    align: "center",
    customRender: function (val) {
      return val.length
        ? `${moment(+val[0]).format("yyyy")}-${moment(+val[1]).format("yyyy")}`
        : "";
    },
  },
  {
    title: "执教内容",
    dataIndex: "teachingContent",
    key: "teachingContent",
    align: "center",
  },
];

import { Empty } from "ant-design-vue";
export default {
  inject: ["getInfo", "getOperatingList"],
  computed: {
    info() {
      return this.getInfo();
    },
    operatingList() {
      return this.getOperatingList();
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      // 教育经历数据
      jyColumns: jyColumns,
      // 执教经历数据
      zjColumns: zjColumns,
      educateData: [
        { id: 1, name: "初中及以下" },
        { id: 2, name: "中专/中技" },
        { id: 3, name: "高中" },
        { id: 4, name: "大专" },
        { id: 5, name: "本科" },
      ],
    };
  },
  mounted() {},
  methods: {
    toIdListName(id, list, key = "name") {
      console.log(id, list);
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          return list[i][key];
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "/src/styles/common/common.less";
.InfoCoach {
  ::v-deep .el-descriptions__body {
    width: 100%;
    background-color: unset;
  }
  ::v-deep .el-descriptions {
    display: flex;
    .el-descriptions-item {
      flex: 1;
    }
    .el-descriptions-row {
      th {
        height: 60px;
        width: 150px;
        color: #BCBCBC;
        font-size: 14px;
        font-weight: bold;
        background-color: #21284b;
      }
      td {
        height: 60px;
        min-width: 200px;
        color: #fff;
        font-size: 12px;
        background-color: #141937;
      }
    }
  }
}
:deep(.ant-descriptions-title) {
  margin-top: 20px !important;
}
.descCont {
  position: relative;
  padding-left: 330px;
}
.avaCont {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-right: none;
  background-color: #141937;
}
::v-deep.memberInfo {
  .ant-table-bordered .ant-table-body > table {
    border: 0 !important;
    border-top: 0 !important;
  }
}
</style>